import {useMMKVNumber} from 'react-native-mmkv';
import {totalScoreKey} from '../storage';

export function useTotalScore() {
  const [totalScore] = useMMKVNumber(totalScoreKey);
  return totalScore || 0;
}
